import { asyncComponent } from 'react-async-component';

const loadComponent = load => asyncComponent({
  resolve: () => load,
});

// Note: you might be wondering why we need `import('...')`
// on every line below. The reason is that parcel will not recognise
// the import function and create the separate chunk otherwise.
// Still better than webpack.

// Home
export const Home = loadComponent(import('./Home'));
// Checkout
export const CheckoutSelectExemption = loadComponent(import('./Checkout/SelectExemption'));
export const CheckoutUploadEvidence = loadComponent(import('./Checkout/UploadProof'));
export const CheckoutPaymentSummary = loadComponent(import('./Checkout/PaymentSummary'));
export const CheckoutPaymentDeliveryPreference = loadComponent(import('./Checkout/PaymentDeliveryPreference'));
// Signup
export const SignupPassword = loadComponent(import('./Signup/Password'));
export const SignupPasswordSuccess = loadComponent(import('./Signup/PasswordSuccess'));
export const SignupName = loadComponent(import('./Signup/Name'));
export const SignupPhoneDOB = loadComponent(import('./Signup/PhoneDob'));
export const SignupGP = loadComponent(import('./Signup/GP'));
export const SignupAddress = loadComponent(import('./Signup/Address'));
export const SignupWaiting = loadComponent(import('./Signup/Waiting'));
// Error
export const Error404 = loadComponent(import('./Error/404'));
export const Maintenance = loadComponent(import('./Error/Maintenance'));
